module.exports = __webpack_public_path__ + "files/bc6a6ed6dd2bf13a87e3f369127d72bd.svg";